export const dataHooks = {
    baseModalLayout: 'baseModalLayout',
    closeButton: 'baseModalLayout-close-button',
    helpButton: 'baseModalLayout-help-button',
    headerTitle: 'baseModalLayout-title',
    headerSubtitle: 'baseModalLayout-subtitle',
    contentWrapper: 'baseModalLayout-content-wrapper',
    footerDivider: 'baseModalLayout-footer-divider',
    primaryButtonTooltip: 'baseModalLayout-footer-primaryButtonTooltip',
    footerSideActions: 'baseModalLayout-side-actions',
    footerPrimaryButton: 'baseModalLayout-primary-button',
    footerSecondaryButton: 'baseModalLayout-secondary-button',
    illustrationSrc: 'baseModalLayout-illustration-src',
};
export const labels = {
    help: 'Help',
    close: 'Close',
};
//# sourceMappingURL=constants.js.map